import { QuestionDTO } from 'jobs/dtos/questions'
import BoolQuestionViewModel from './Bool/BoolQuestionViewModel'
import BreakerQuestionViewModel from './Breaker/BreakerQuestionViewModel'
import { QuestionViewModel } from './component-registry'
import DateTimeQuestionViewModel from './DateTime/DateTimeQuestionViewModel'
import DocumentsQuestionViewModel from './Documents/DocumentsQuestionViewModel'
import NumericQuestionViewModel from './Numeric/NumericQuestionViewModel'
import { QuestionViewModelPort } from './QuestionViewModelBase'
import SelectQuestionViewModel from './Select/SelectQuestionViewModel'
import TextQuestionViewModel from './Text/TextQuestionViewModel'
import UnknownQuestionViewModel from './Unknown/UnknownQuestionViewModel'

/**
 * Gets the Question view model constructor for the specified type.
 *
 * @param type
 */
export function getQuestionViewModelConstructor(type: QuestionDTO['type']) {
  return viewModelRegistry[type] || UnknownQuestionViewModel
}

const viewModelRegistry: QuestionViewModelRegistry = {
  BOOL: BoolQuestionViewModel,
  TEXT: TextQuestionViewModel,
  NUMERIC: NumericQuestionViewModel,
  DATE_TIME: DateTimeQuestionViewModel,
  DOCUMENTS: DocumentsQuestionViewModel,
  SELECT: SelectQuestionViewModel,
  BREAKER: BreakerQuestionViewModel,
}

export type QuestionViewModelRegistry = {
  [P in QuestionDTO['type']]: new (
    adapter: QuestionViewModelPort,
  ) => QuestionViewModelFor<Extract<QuestionDTO, { type: P }>>
}

/**
 * Helper for extracting a question view model.
 */
export type QuestionViewModelFor<T extends QuestionDTO> = Extract<
  QuestionViewModel,
  { type: T['type'] | 'UNKNOWN' }
>
